<main>
  @if (message) {
    <nz-alert
      [nzMessage]="message.text"
      [nzType]="message.type"
      nzShowIcon
    ></nz-alert>
  }
  <nz-card nzAlign="center">
    <header>Вход в систему</header>

    <form nz-form [formGroup]="form" class="login-form" (ngSubmit)="submitForm()">
      <nz-form-control nzErrorTip="Введите логин">
        <label for="login">Логин</label>
        <input
          id="login"
          type="text"
          nz-input
          formControlName="login"
          placeholder="User"
          />
      </nz-form-control>

      <nz-form-control nzErrorTip="Введите пароль">
        <label for="password">
          Пароль
          <i
            nz-icon
            class="toggle-password"
            [nzType]="passwordVisible ? 'eye' : 'eye-invisible'"
            (click)="passwordVisible = !passwordVisible"
          ></i>
        </label>
        <input
          id="password"
          [type]="passwordVisible ? 'text' : 'password'"
          nz-input
          formControlName="password"
          placeholder=" "
          />
      </nz-form-control>

      <nz-form-control>
        <button
          [disabled]="form.invalid"
          [nzLoading]="submitted"
          nz-button
          class="login-form-button login-form-margin"
          [nzType]="'primary'"
          >
          Войти
        </button>
      </nz-form-control>
    </form>
    @if (error) {
      <span nz-typography nzType="danger">
        {{ errorText }}
      </span>
    }
  </nz-card>
</main>
